<app-scroll-top></app-scroll-top>
<div class="mondat-page min-h-50">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Nos mandats</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            NOS <span style="color : #BADFFF"> MANDATS </span>
                        </h1>
                        <h6 class="description">
                            Découvrez nos mandats. Choisissez la formule qui convient à 100% pour votre projet
                            immobilier
                        </h6>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mondat-bloc py-5">
        <div class="bloc-mondat">
            <div>
                <div class="container py-3" id="mondat-premium">
                    <div class="row py-3 text-center fw-bolder text-uppercase">
<!--                        <h3 class="">LE MANDAT PREMIUM<br><span class="text-bleu-tdm">100% PARTAGÉ</span></h3>-->
                        <h3 class="">Mandat PREMIUM<br><span class="text-bleu-tdm">votre vente propulsée par la force d’un réseau</span></h3>
                    </div>
                    <div class="row row-cols-md-2 row-cols-sm-1 py-3">
                        <div>
                            <!-- <div class="img-bg-bloc-ami"><div class="img-bloc-ami"></div></div> -->
                            <img width="651" height="537" src="assets/home/Premium.png" class="img-fluid"
                                 alt="Rencontrez nos Conseillers en immobilier">
                        </div>
                        <div class="align-self-md-center mt-4 mt-md-0">

                          <p>Choisissez la puissance d’un seul interlocuteur dédié qui partage votre bien auprès de <strong>100 %</strong> des professionnels de votre secteur : toute l’équipe THE DOOR MAN concentre son énergie pour trouver l’acheteur idéal, rapidement et au meilleur prix.</p>
                          <ul>
                            <li><strong>Force commerciale décuplée :</strong> grâce à notre réseau national, chaque conseiller en immobilier partout en France peut présenter votre bien à l’ensemble de ses clients.</li>
                            <li><strong>Simplicité et efficacité :</strong> un conseiller unique pour piloter la diffusion, organiser les visites, négocier et sécuriser la transaction.</li>
                            <li><strong>Transparence totale :</strong> en cas d’inter cabinet, nous partageons nos honoraires à parts égales avec le confrère, sans supplément pour vous.
                              <br/>Résultat : une vente plus rapide, plus sereine, et optimale sur le plan financier.</li>
                            <li><strong>Une diffusion illimitée :</strong> votre bien est diffusé en illimité sur tous les sites leaders de diffusions d’annonces, sans exception. Votre bien est présent partout !</li>
                          </ul>
                        </div>
                    </div>
                </div>
                    <div id="mondat-flash" class="gradient01 text-white py-5">
                        <div class="container">
                            <div class="row py-3 text-center fw-semibold text-uppercase text-white">
                                <h3 class="">LE MANDAT FLASH<br><span class="">ENCHERES INTERACTIVES</span></h3>
                            </div>
                            <div class="row row-cols-md-2 row-cols-sm-1 py-3">
                                <div>
                                    <!--    <div class="img-bg-bloc-ami"><div class="img-bloc-ami"></div></div>-->
                                    <img width="651" height="537" src="assets/home/Flash.png" class="img-fluid"
                                        alt="Rencontrez nos Conseillers en immobilier">
                                </div>
                                <div class="align-self-md-center mt-4 mt-md-0">
                                    <p>Notre Mandat <strong>FLASH</strong> est le mandat idéal pour réussir la vente de votre
                                        bien dans deux situations distinctes que vous pouvez rencontrer !<br /><br />
                                        Votre bien à vendre est dans un marché tendu où le nombre d’acheteur est
                                        supérieur à l’offre proposée. Choisissez notre Mandat <strong>FLASH</strong>
                                        avec son système d’enchères progressives et mettez les acquéreurs en concurrence
                                        pour vendre au prix le plus élevé !<br /><br />
                                        Vous devez vendre rapidement et vous n’avez que quelques semaines pour
                                        trouver votre futur acheteur, choisissez notre Mandat <strong>FLASH</strong>
                                        avec son système d’enchères dégressives et vendez votre bien plus rapidement
                                        qu’aucune autre solution sur le marché et au meilleur prix possible.<br />
                                        <a href="https://www.thedoorman-encheres.immo/index.html"
                                           target="_blank">https://www.thedoorman-encheres.immo/index.html
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="container py-3" id="mondat-access">
                        <div class="row py-3 text-center fw-semibold text-uppercase">
                            <h3 class="">LE MANDAT SIMPLE
<!--                              <br><span class="text-bleu-tdm">EN TOUTE LIBERTE !</span>-->
                            </h3>
                        </div>
                        <div class="row row-cols-md-2 row-cols-sm-1 py-3">
                            <div>
                                <!-- <div class="img-bg-bloc-ami"><div class="img-bloc-ami"></div></div> -->
                                <img width="651" height="537" src="assets/home/Access.png" class="img-fluid"
                                     alt="Rencontrez nos Conseillers en immobilier">
                            </div>
                            <div class="align-self-md-center mt-4 mt-md-0">
                              <p>Le Mandat Simple vous offre la flexibilité de vendre par vous-même ou avec d’autres professionnels mais pour cela vous devez multiplier les mandats avec les risques que cela peut engendrer.</p>
                              <p>Dans le cadre du mandat simple chez THE DOOR MAN :</p>
                              <ul>
                                <li><strong>Diffusion ciblée :</strong> votre bien est publié sur les sites d’annonces, mais de manière plus restreinte qu’en Mandat Premium.</li>
                                <li><strong>Accompagnement modulable :</strong> gestion des visites et suivi administratif ponctuel par votre conseiller THE DOOR MAN.</li>
                                <li><strong>Aucune exclusivité :</strong> vous pouvez parallèlement confier votre bien à plusieurs agences ou le vendre seul.</li>
                              </ul>
                            </div>
                        </div>
                    </div>
                    <div class="container py-3">
                        <div class=" row row-cols-md-2 row-cols-sm-1 py-3">
                            <div class="ami-join-us-cta align-self-md-center text-center text-md-start">
                                <div>
                                    <h4 class="text-uppercase">Et si vous deveniez <span class="bleutdm">Conseiller en
                                            immobilier ou indicateur d'affaires</span>
                                        ?
                                        Découvrez toutes nos opportunités !</h4>
                                </div>
                                <div class="text-center text-md-start my-3">
                                    <button (click)="onNavigateRejoindre()"
                                        class="btn btn-primary external-link-white px-4 my-1 py-3  fw-bold">Nous
                                        rejoindre</button>
                                </div>
                            </div>
                            <div class="ami-join-us-pictur">
                                <div class="text-end">
                                    <img width="800" height="533" class="w-100 h-auto" src="assets/home/bureau-tdm.webp" alt="Rejoignez The Door Man">
                                </div>
                            </div>
                        </div>
                    </div>
              </div>
        </div>
    </div>
</div>
